import React, { Component } from 'react';
import {
  ArtboardContainer,
  FullPageLoaderContainer,
  DocumentContainer,
} from '../../../artboard/styles';
import { withTranslation } from 'react-i18next';
import { getTemplate, getVoicesTemplate } from '../../../utils/services/shortMessageTemplateAPI';
import Loader from '../../Loader';
import FormattingToolbar from '../ToolBar/FormattingToolbar';
import ShortMessageChannels from '../EditingArea/Channels';
import PublishOverlay from '../PublishCycle/PublishOverlay';
import NoSuchEnvironment from '../../../artboard/NoSuchEnv';
import { jsonToShortMessage } from '../../../utils/JsonConversion/jsonToShortMessage';
import { IS_WHATSAPP_ENABLED } from '../../../utils/helper';

/* This component contains the toolBar, editing area and publish cycle
  Child Components: 
    * FormattingToolbar
    * ShortMessageChannels
    * NoSuchEnvironment
    * PublishOverlay 
*/

class MessageContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      templateId: undefined,
      isNotYetSend: undefined,
      nonDraftEnvVoiceName: undefined,
      currentEnv: 'draft',
      isFetchingDetails: true,
    };
    this.fetchTemplateData = this.fetchTemplateData.bind(this);
  }

  componentDidMount() {
    if (this.props.templateId && this.props.userAuthenticated) {
      this.setState({ isFetchingDetails: true });
      this.fetchTemplateData(this.props.templateId);
      this.setState({ templateId: this.props.templateId });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.templateId !== prevProps.templateId) {
      this.setState({ isFetchingDetails: true });
      this.fetchTemplateData(this.props.templateId);
      this.setState({ templateId: this.props.templateId });
    }
  }

  removeDuplicatesFromArray = (array, key) => {
    const { globalVariables } = this.props;
    let UniqueArray;
    UniqueArray = [...new Map(array.map(m => [m[key], m])).values()];
    UniqueArray.map(variable => {
      let filteredVar = globalVariables.filter(globalVar => globalVar.id === variable.variableId);
      if (filteredVar?.length > 0) {
        filteredVar = filteredVar[0];
        variable.name = filteredVar.placeHolderText;
        variable.defaultValue = filteredVar.exampleValue;
        variable.maxLength = filteredVar.length;
        variable.count = filteredVar.count;
        variable.type = filteredVar.type;
      }
    });
    return UniqueArray;
  };

  updateDocumentVariables = (selectedVariable, channel) => {
    const { variableList } = this.state;
    if (channel && variableList && selectedVariable) {
      const uniqueVar = this.removeDuplicatesFromArray(selectedVariable, 'variableId');
      if (uniqueVar) {
        if (channel === 'call') variableList.callVariables = uniqueVar;
        if (channel === 'Message') variableList.smsVariables = uniqueVar;
        if (IS_WHATSAPP_ENABLED && channel === 'Whatsapp') variableList.whatsappVariables = uniqueVar;
        this.setState({ variableList: variableList });
        let allVariableList = [
          ...variableList.callVariables,
          ...variableList.smsVariables,
          ...(IS_WHATSAPP_ENABLED ?  variableList.whatsappVariables: [])
        ];
        let uniqueVarList = this.removeDuplicatesFromArray(allVariableList, 'variableId');
        this.props.updateDocumentVariables([...uniqueVarList]);
      }
    }
  };

  handleTemplateResponse = async response => {
    const { documentVariables, showVersions } = this.props;
    this.setState({ isNotYetSend: undefined });
    if (!showVersions && documentVariables && documentVariables.length > 0) {
      this.props.updateDocumentVariables([]);
    }
    const { globalVariables } = this.props;
    if (globalVariables) {
      const shortMessageContent = await jsonToShortMessage(response.data[0], globalVariables);
      this.setState({ shortMessageContent });
      if (!showVersions) {
        let variableList = shortMessageContent?.variableList;
        this.setState({ variableList });
        let allVariableList = [
          ...variableList.callVariables,
          ...variableList.smsVariables,
          ...(IS_WHATSAPP_ENABLED ? variableList.whatsappVariables: [])
        ];
        this.props.updateDocumentVariables(allVariableList);
        this.setState({ availableChannels: [1, 2] });
      } else {
        let availableChannels = [];
        let shortMessageText = shortMessageContent?.shortMessageText;
        if (IS_WHATSAPP_ENABLED && shortMessageText.whatsapp.length !== 0) availableChannels.push(0);
        if (shortMessageText.sms.length !== 0) availableChannels.push(1);
        if (shortMessageText.call.length !== 0) availableChannels.push(2);
        let inTestEnvChannel = [];
        let pubishedChannel = [];
        if (response.data[0]?.voiceName) {
          this.setState({ nonDraftEnvVoiceName: response.data[0]?.voiceName });
        }
        if (response.data[0].whatsappPublishStatus === 'testing') {
          inTestEnvChannel.push('whatsapp');
        } else if (response.data[0].whatsappPublishStatus === 'complete') {
          pubishedChannel.push('whatsapp');
        }
        if (response.data[0].smsPublishStatus === 'testing') {
          inTestEnvChannel.push('sms');
        } else if (response.data[0].smsPublishStatus === 'complete') {
          pubishedChannel.push('sms');
        }

        if (response.data[0].callPublishStatus === 'testing') {
          inTestEnvChannel.push('call');
        } else if (response.data[0].callPublishStatus === 'complete') {
          pubishedChannel.push('call');
        }

        this.setState({ availableChannels, inTestEnvChannel, pubishedChannel });
      }
    }
    this.setState({ isFetchingDetails: false });
  };

  fetchTemplateData = async templateId => {
    let templateResponse = await getTemplate(templateId);
    if (templateResponse) {
      if (templateResponse && templateResponse.errors && templateResponse.errors.length === 0) {
        if (templateResponse?.data && templateResponse?.data.length > 0) {
          let channelEnv = [
            ...(IS_WHATSAPP_ENABLED ? [templateResponse?.data[0]?.whatsappPublishStatus] : []),
            templateResponse?.data[0]?.smsPublishStatus,
            templateResponse?.data[0]?.callPublishStatus,
          ];
          this.props.setIsDraft(channelEnv?.includes('draft') ? true : false);
          const payload = {};
          if (templateResponse.data[0].language) {
            payload.language = templateResponse.data[0].language;
          } else {
            payload.language = 'en';
          }
          if (templateResponse.data[0].updatedOn) {
            this.setState({ draftUpdatedOn: templateResponse.data[0].updatedOn });
          }
          let voicesList = await getVoicesTemplate(payload);
          //Modifying the voicesList so that voice containing 'WaveNet' appears at the top 
          voicesList.data.map((voice, index) => {
            if(voice.voiceName?.includes("Wavenet")) {
              voicesList.data.splice(index, 1);
              voicesList.data.unshift(voice);
            }
          });

          if (voicesList && voicesList?.data) {
            this.setState({ voicesList: voicesList?.data });
            this.props.setVoiceName(
              templateResponse.data[0].voiceName
                ? templateResponse.data[0].voiceName
                : voicesList?.data?.length > 0
                ? voicesList?.data[0].voiceName
                : '',
            );
          }
          this.handleTemplateResponse(templateResponse);
        } else {
          this.setState({ isFetchingDetails: false });
        }
      } else {
        this.props.history.push('/notFound');
        this.setState({ isFetchingDetails: false });
      }
    }
  };

  saveTempDraft = () => {
    this.props.onHandleVersion(true);
  };

  retriveDraft = data => {
    this.setState({ isFetchingDetails: true });
    this.props.onHandleVersion(false);
    this.handleTemplateResponse(data);
  };

  handleChannelWithoutData = e => {
    this.setState({ shortMessageContent: undefined, isNotYetSend: e });
  };

  render() {
    const { showVersions, variablesFetched, globalVariables } = this.props;
    const {
      isFetchingDetails,
      shortMessageContent,
      templateId,
      voicesList,
      variableList,
      isNotYetSend,
      availableChannels,
      inTestEnvChannel,
      pubishedChannel,
      nonDraftEnvVoiceName,
      currentEnv,
      draftUpdatedOn,
    } = this.state;

    return (
      <ArtboardContainer>
        {(isFetchingDetails || !variablesFetched) && (
          <FullPageLoaderContainer>
            <Loader fullpage="true" />
          </FullPageLoaderContainer>
        )}
        <DocumentContainer>
          <FormattingToolbar
            templateId={templateId}
            onVersionClick={() => {
              this.saveTempDraft();
            }}
            showVersions={showVersions}
          />
          {showVersions && isNotYetSend ? (
            <NoSuchEnvironment testVersion={isNotYetSend === 'testing'} />
          ) : (
            <ShortMessageChannels
              shortMsgContent={shortMessageContent}
              tabIndex={this.props.tabIndex}
              voicesList={voicesList}
              updateDocumentVariables={this.updateDocumentVariables}
              variableList={variableList}
              showVersions={showVersions}
              availableChannels={availableChannels}
              nonDraftVoice={nonDraftEnvVoiceName}
              currentEnv={currentEnv}
            />
          )}
        </DocumentContainer>
        {showVersions && (
          <PublishOverlay
            onCancel={e => this.retriveDraft(e)}
            templateId={templateId}
            globalVariables={globalVariables}
            onFetchingDetails={e => this.setState({ isFetchingDetails: e })}
            handleResponse={e => this.handleTemplateResponse(e)}
            isNotYetSend={e => this.handleChannelWithoutData(e)}
            changeCurrentEnv={e => this.setState({ currentEnv: e })}
            inTestEnvChannel={inTestEnvChannel}
            pubishedChannel={pubishedChannel}
            draftUpdatedOn={draftUpdatedOn}
          />
        )}
      </ArtboardContainer>
    );
  }
}

export default withTranslation()(MessageContainer);
